import { render } from "./WorkflowsNew.vue?vue&type=template&id=19a60c58&scoped=true&lang=pug"
import script from "./WorkflowsNew.js?vue&type=script&lang=js&external"
export * from "./WorkflowsNew.js?vue&type=script&lang=js&external"

import "./WorkflowsNew.vue?vue&type=style&index=0&id=19a60c58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a60c58"]])

export default __exports__